export default __webpack_public_path__ + "static/media/toggle.f7ca2fff.svg";